module.exports = __webpack_public_path__ + "media/images/menu/vulpecula-0cee4fdc5987215c748c1ff7c8a4f286.jpg";